import { useContext, useEffect, useState } from 'react';

import { Container } from 'react-bootstrap';

import styles from './Home.module.css';
import { UserContext } from '../../context/UserContext';
import { decrypt } from '../../helpers/cryptography';

const Home = () => {
  const { login } = useContext(UserContext);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    if (login) {
      const data = JSON.parse(localStorage.getItem('login'));
      const email = decrypt(data?.user?.email);

      if (data) {
        setEmail(email);
      }
    }

    if (!login) {
      setEmail(null);
    }
  }, [login]);

  return (
    <Container className={styles.container}>
      {email && <p>{email}</p>}
      <svg
        className={styles.svg}
        xmlns="http://www.w3.org/2000/svg"
        width={180}
        height={130}
        viewBox="120 350 180 130"
        fill="none"
      >
        <path d="M 176.2808,390.8432 C 176.2808,380.7102 167.9699,372.4927 157.7217,372.4927 147.4735,372.4927 139.1626,380.7102 139.1626,390.8432 139.1626,400.9762 147.4735,409.1937 157.7217,409.1937 167.9699,409.1937 176.2808,400.9762 176.2808,390.8432 Z" stroke="#FF7A1C" strokeWidth="2" strokeLinecap="round" />
        <path d="M 159.1541,427.0444 L 159.1541,460.8817 142.6359,460.8817 142.6359,440.4592 137.23,440.4592 137.23,460.8817 124.6161,460.8817 124.6161,433.5516 C 126.7184,418.4349 139.4324,413.4294 144.538,413.4294 L 165.6613,413.4294 C 163.7592,416.2325 160.6558,417.634 159.1541,427.0444 Z" stroke="#FF7A1C" strokeWidth="2" strokeLinecap="round" />

        <path d="M 223.8882,381.5371 C 223.8882,369.9632 214.5022,360.5772 202.9284,360.5772 191.3545,360.5772 181.9685,369.9632 181.9685,381.5371 181.9685,393.1109 191.3545,402.4969 202.9284,402.4969 214.5022,402.4969 223.8882,393.1109 223.8882,381.5371 Z" stroke="#005CAE" strokeWidth="2" strokeLinecap="round" />
        <path d="M 241.3164,429.7579 L 241.3164,461.0008 223.0124,461.0008 223.0124,455.4255 229.4293,455.4255 229.4293,445.9579 223.0124,445.9579 223.0124,439.8566 213.6501,439.8566 213.6501,445.9579 207.5487,445.9579 207.5487,455.4255 213.6501,455.4255 213.5449,461.0008 165.6811,461.0008 165.6811,429.4423 C 169.1525,412.5059 185.037,409.5604 189.876,407.7721 L 202.6046,423.867 216.7007,407.9825 C 237.7397,414.0838 239.1073,423.867 241.3164,429.7579 Z" stroke="#005CAE" strokeWidth="2" strokeLinecap="round" />

        <path d="M 230.1692,390.8336 C 230.1692,380.7006 238.4801,372.4831 248.7283,372.4831 258.9764,372.4831 267.2873,380.7006 267.2873,390.8336 267.2873,400.9666 258.9764,409.1841 248.7283,409.1841 238.4801,409.1841 230.1692,400.9666 230.1692,390.8336 Z" stroke="#FF2B3E" strokeWidth="2" strokeLinecap="round" />
        <path d="M 247.2958,427.0348 L 247.2958,460.8721 263.814,460.8721 263.814,440.4496 269.22,440.4496 269.22,460.8721 281.8339,460.8721 281.8339,433.542 C 279.7316,418.4253 267.0176,413.4198 261.9119,413.4198 L 240.7887,413.4198 C 242.6908,416.2229 245.7942,417.6244 247.2958,427.0348 Z" stroke="#FF2B3E" strokeWidth="2" strokeLinecap="round" />
      </svg>

      <div className={styles.show_img}>
        <div className={styles.img}>
          <img
            width={158}
            height={65}
            src="../assets/img/fesaude3.png"
            alt="FeSaúde Niterói" />
        </div>
        <div>
          <h1 className={styles.abbr}>SisGeD</h1>
          <h2 className={styles.abbr_text}>Sistema de Gestão de Demandas</h2>
        </div>
      </div>
    </Container>
  );
};

export default Home;
